import { AuthService } from './../serv/auth.service';
import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { AppUser } from '../Models/app-user';


declare const $: any;
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {
  @Input() founder: string = "Osmani Youcef";
  @Output() smothScrolling = new EventEmitter<MouseEvent>();

  appUser : AppUser;
  constructor(private auth: AuthService) {}
  
 
  async ngOnInit() {
    this.auth.appUser$.subscribe( appUser => this.appUser = appUser);
  }

  logoutGO() {
    this.auth.logoutwithgoogle();
  };

  scroll(event: MouseEvent) {
    const hash = event.srcElement["hash"];
    $('html, body').animate({ scrollTop: $(hash).offset().top }, 700);
  };


  fonction() {
    var pixels = 50;
    var top = 1200;

  }

  ngAfterViewInit() {
    this.displaySlider();
  }

  smothScroll(event: any) {
    this.smothScrolling.emit(event);
  }


  displaySlider() {
    //new WOW().init();
    var TxtType = function (el, toRotate, period) {
      this.toRotate = toRotate;
      this.el = el;
      this.loopNum = 0;
      this.period = parseInt(period, 10) || 1000;
      this.txt = '';
      this.tick();
      this.isDeleting = false;
    };

    TxtType.prototype.tick = function () {
      var i = this.loopNum % this.toRotate.length;
      var fullTxt = this.toRotate[i];

      if (this.isDeleting) {
        this.txt = fullTxt.substring(0, this.txt.length - 1);
      } else {
        this.txt = fullTxt.substring(0, this.txt.length + 1);
      }

      this.el.innerHTML = '<span class="wrap">' + this.txt + '</span>';

      var that = this;
      var delta = 150 - Math.random() * 100;

      if (this.isDeleting) {
        delta /= 2;
      }

      if (!this.isDeleting && this.txt === fullTxt) {
        delta = this.period;
        this.isDeleting = true;
      } else if (this.isDeleting && this.txt === '') {
        this.isDeleting = false;
        this.loopNum++;
        delta = 500;
      }

      setTimeout(function () {
        that.tick();
      }, delta);
    };

    var elements = document.getElementsByClassName('typewrite');

    for (var i = 0; i < elements.length; i++) {
      var toRotate = elements[i].getAttribute('data-type');
      var period = elements[i].getAttribute('data-period');
      if (toRotate) {
        new TxtType(elements[i], JSON.parse(toRotate), period);
      }
    }

    // // INJECT CSS
    var css = document.createElement("style");
    css.type = "text/css";
    css.innerHTML = ".typewrite > .wrap { border-right: 0.04em solid #FFFFFF}";
    document.body.appendChild(css);

  }
}
